import { Form, Input, Modal, Table, Radio, Select, notification, Card, Space } from 'antd'
import { useContext, useEffect, useState } from 'react'
import { PlusCircleTwoTone, ExclamationCircleOutlined } from '@ant-design/icons'

import './styles.css'

import { Context } from '../../context'
import { Fetch, Post, Delete, Put } from '../../fetch'
import { convertIdToKey } from '../../utils'
import { validateLinkedinInput, validateOptionalDescriptionFields, validateOptionalInputFields, validateTwitterInput, validateWebsiteInput, validateYoutubeInput } from '../../validators'

import UploadBanners from '../UploadBanners/index'

const { Column } = Table
const { Option } = Select
const { confirm } = Modal
const { TextArea } = Input

const ManageCreators = () => {
    const { token, apiUrl } = useContext(Context)

    const [mediaHouses, setMediaHouses] = useState([])
    const [modalVisible, setModalVisible] = useState(false)
    const [modalType, setModalType] = useState("Add");
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [mediaHousesMaster, setMediaHousesMaster] = useState([])
    const [mhType, setMhType] = useState("Host")
    const [crewId, setCrewId] = useState(null);

    const [form] = Form.useForm()

    useEffect(() => {
        Fetch(`${apiUrl}/creator`, token, (result) => {
            const creators = convertIdToKey(result.creators);
            setMediaHouses(creators);
            setMediaHousesMaster(creators);
        })
    }, [apiUrl, token, confirmLoading])

    const handleSubmit = async () => {
        try {
            setConfirmLoading(true)
            let values = await form.validateFields();
            if (modalType === "Add") {
                Post(
                    `${apiUrl}/creator`,
                    token,
                    {
                        ...values
                    },
                    (result) => {
                        if (result.success) {
                            notification.success({
                                message: 'Success',
                                description: 'Creator added'
                            })
                            form.resetFields()
                            setModalVisible(false)
                            setConfirmLoading(false);
                            setCrewId(null);
                            setModalType("Add");
                        }
                        else if (result.success === false) {
                            notification.error({
                                message: "Failed",
                                description: "Another record with same details already exists"
                            })
                            setConfirmLoading(false)
                        }
                        else {
                            setConfirmLoading(false)
                            notification.error({
                                message: "Unauthorized",
                                description: "Contact your admin for details"
                            })
                        }
                    },
                    () => {
                        notification.error({
                            message: 'Add Creator Error',
                            description: 'Check console for more details'
                        })
                        setConfirmLoading(false)
                    }
                )
                return;
            }
            if (!crewId) {
                return;
            }
            Put(
                `${apiUrl}/creator/${crewId}`,
                token,
                { ...values },
                (result) => {
                    if (result.success) {
                        notification.success({
                            message: "Success",
                            description: "Creator Updated Successfully"
                        })
                        form.resetFields()
                        setModalVisible(false)
                        setConfirmLoading(false);
                        setCrewId(null);
                        setModalType("Add");
                    } else if (result.success === false) {
                        notification.error({
                            message: "Update Creator Error",
                            description: result["message"]
                        })
                        setConfirmLoading(false);
                    } else {
                        setConfirmLoading(false)
                        notification.error({
                            message: "Unauthorized",
                            description: "Contact your admin for details"
                        })
                    }
                }
            )
        } catch (err) {
            console.error(err)
            setConfirmLoading(false)
            notification.error({
                message: 'Add Creator Error',
                description: 'Required fields are incorrect/missing'
            })
        }
    }

    const getEditModal = (id) => {
        Fetch(
            `${apiUrl}/creator/${id}`,
            token,
            (result) => {
                if (result.success) {
                    setCrewId(id);
                    form.setFieldsValue(result.creator);
                    setModalType("Edit");
                    setModalVisible(true);
                }
            }
        )
    }

    const handleDelete = async (id) => {
        confirm({
            title: 'Are you sure?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                try {
                    setConfirmLoading(true)
                    Delete(
                        `${apiUrl}/creator/${id}`,
                        token,
                        (result) => {
                            if (result.success) {
                                notification.success({
                                    message: 'Success',
                                    description: 'Creator deleted successfully'
                                })
                                setConfirmLoading(false)
                            }
                        },
                        () => {
                            setConfirmLoading(false)
                            notification.error({
                                message: 'Delete Creator Error',
                                description: 'Please check your permissions'
                            })
                        }
                    )
                } finally {
                }
            }
        })
    }

    const handleSearchChange = (mId) => {
        if (!mId)
            return

        for (const a in mediaHousesMaster) {
            if (mediaHousesMaster[a].key === mId) {
                setMediaHouses([mediaHousesMaster[a]])
                break
            }
        }
    }

    const validateInputLength = (_, value) => {
        if (!value) {
            return Promise.reject(new Error("Name is mandatory"));
        }
        if (!(/^[a-zA-Z][a-zA-Z\s]*$/).test(value)) {
            return Promise.reject(new Error('Input cannot start with a space and contains only Alphabets and spaces'));
        }
        if (value && (value.length < 3 || value.length > 35)) {
            return Promise.reject(new Error('Input must be between 3-35 characters'));
        }
        return Promise.resolve();
    };

    return (
        <div className="manage-episodes-wrapper">
            <Select
                placeholder="Search Creator"
                showSearch
                allowClear
                onChange={handleSearchChange}
                onClear={() => setMediaHouses(mediaHousesMaster)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                    optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                }
            >
                {mediaHousesMaster.map((mh) => (
                    <Option value={mh.key}>{mh.name}</Option>
                ))}
            </Select>
            <Table dataSource={mediaHouses}>
                <Column title="Name" dataIndex="name" key="name" align="center" />
                <Column title="Profile Image" dataIndex={"profileImage"} key={"profileImage"} align='center'
                    render={(_, record) => record.profileImage ? <img src={record.profileImage} style={{ borderRadius: "50%" }} width={100} height={100} /> : "-"}
                />
                <Column
                    title="Available Social Handles"
                    align='center'
                    render={(_, record) => {
                        return (
                            <Space direction='horizontal' align='baseline'>
                                {
                                    record.website ? <img src='/images/website.svg' /> : null
                                }
                                {
                                    record.youtube ? <img src='/images/youtube.svg' /> : null
                                }
                                {
                                    record.linkedin ? <img src='/images/linkedin.svg' /> : null
                                }
                                {
                                    record.twitter ? <img src='/images/twitter.svg' /> : null
                                }

                                {
                                    record?.instagram ? <img src="/images/instagram.svg"/> : null
                                }
                                {
                                    !record.website && !record.youtube && !record.linkedin && !record.twitter && !record?.instagram ? "-" : null
                                }
                            </Space>
                        )
                    }}
                />
                <Column
                    title="Actions"
                    key="action"
                    align="center"
                    render={(text, record) => (
                        <Space>
                            <a onClick={() => getEditModal(record.key)}>Edit</a>
                            <a onClick={() => handleDelete(record.key)}>Delete</a>
                        </Space>
                    )}
                />
            </Table>
            <PlusCircleTwoTone
                twoToneColor="#1890FF"
                style={{ fontSize: '48px' }}
                className="add-media-house-btn"
                onClick={() => setModalVisible(true)}
            />
            <Modal
                title={`${modalType} Creator`}
                open={modalVisible}
                onOk={handleSubmit}
                okText="Submit"
                onCancel={() => { setModalVisible(false); form.resetFields(); setModalType("Add"); setMhType("Host") }}
                confirmLoading={confirmLoading}
                maskClosable={false}
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item name="name" label="Name"
                        rules={
                            [{
                                required: true,
                                validator: validateInputLength
                            }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={"company"}
                        label="Company"
                        rules={
                            [{
                                required: false,
                                validator: validateOptionalInputFields,
                            }]
                        }
                    >
                        <Input placeholder='Enter company name' />
                    </Form.Item>
                    <Form.Item
                        name={"designation"}
                        label="Designation"
                        rules={[{
                            required: false,
                            validator: validateOptionalInputFields
                        }]}
                    >
                        <Input placeholder='Enter role in the company' />
                    </Form.Item>
                    <Form.Item
                        name={"about"}
                        label="About"
                        rules={
                            [{
                                required: false,
                                validator: validateOptionalDescriptionFields,
                            }]
                        }
                    >
                        <TextArea placeholder='Enter about' maxLength={1000} showCount={true} rows={10} />
                    </Form.Item>
                    <Form.Item
                        name={"profileImage"}
                        label="Profile Image"
                        rules={[{ required: false }]}
                    >
                        <UploadBanners name="profileImage" updateForm={form} />
                    </Form.Item>
                    <p>Social Handles</p>
                    <Card>
                        <Space direction='vertical'>
                            <Space direction='horizontal' align='baseline'>
                                <img src='/images/website.svg' height={25} width={25} />
                                <Form.Item
                                    name={"website"}
                                    rules={[{
                                        required: false,
                                        validator: validateWebsiteInput,
                                    }]}
                                >
                                    <Input placeholder='Enter website' style={{ width: "200%" }} />
                                </Form.Item>
                            </Space>
                            <Space direction='horizontal' align='baseline'>
                                <img src='/images/youtube.svg' height={25} width={25} />
                                <Form.Item
                                    name={"youtube"}
                                    rules={[{
                                        required: false,
                                        validator: validateYoutubeInput
                                    }]}
                                >
                                    <Input placeholder='Input youtube handle' style={{ width: "200%" }} />
                                </Form.Item>
                            </Space>
                            <Space direction='horizontal' align='baseline'>
                                <img src='/images/linkedin.svg' height={25} width={25} />
                                <Form.Item
                                    name={"linkedin"}
                                    rules={[{
                                        required: false,
                                        validator: validateLinkedinInput,
                                    }]}
                                >
                                    <Input placeholder='Input linkedin handle' style={{ width: "200%" }} />
                                </Form.Item>
                            </Space>
                            <Space direction='horizontal' align='baseline'>
                                <img src='/images/twitter.svg' height={25} width={25} />
                                <Form.Item
                                    name={"twitter"}
                                    rules={[{
                                        required: false,
                                        validator: validateTwitterInput,
                                    }]}
                                >
                                    <Input placeholder='Input twitter handle' style={{ width: "200%" }} />
                                </Form.Item>
                            </Space>
                        </Space>
                    </Card>
                </Form>
            </Modal>
        </div>
    );
}

export default ManageCreators;
